import React, { useState } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { css } from '@emotion/core'
import { ButtonType } from '@/components/atoms/button'
import { FrontTabletButton } from '@/components/molecules/front-tablet/button'
import { createSelfCheckinResponsiveStyle, FrontTabletResponsiveToken } from '@/utils/front-tablet-responsive-style'

type Props = {
  onClick: () => void
}

export const PrinterUnavailableNotice: React.FC<Props> = props => {
  const { t } = useTranslation()
  const [isShowDetailText, setIsShowDetailText] = useState(false)
  const [isCooldown, setIsCooldown] = useState(false)

  const handleClick = async () => {
    if (isCooldown) {
      return
    }
    setIsCooldown(true)
    try {
      await props.onClick()
    } catch (e) {
      //
    } finally {
      setIsCooldown(false)
    }
  }

  return (
    <div css={componentStyle}>
      <div className="cannot-print-text" onClick={() => setIsShowDetailText(!isShowDetailText)}>
        {t('SelfCheckIn.printErrorTitle')}
      </div>
      {isShowDetailText && (
        <div className="cannot-print-text-detail">
          <div>
            <Trans i18nKey={'SelfCheckIn.printErrorDescription'} />
          </div>
          <FrontTabletButton
            height={48}
            buttonType={isCooldown ? ButtonType.BorderDisabled : ButtonType.Secondary}
            isDisabled={isCooldown}
            onClick={handleClick}
            customCss={reprintButtonStyle}
          >
            {t('SelfCheckIn.reprintButton')}
          </FrontTabletButton>
        </div>
      )}
    </div>
  )
}

const reprintButtonStyle = css(
  createSelfCheckinResponsiveStyle({
    landscape11: { fontSize: FrontTabletResponsiveToken.standardButtonFontSize.landscape11 },
    portrait: { fontSize: FrontTabletResponsiveToken.standardButtonFontSize.portrait },
    landscape13: { fontSize: FrontTabletResponsiveToken.standardButtonFontSize.landscape13 },
  }),
)

const componentStyle = css({
  padding: '0 60px 16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  '.cannot-print-text': {
    fontSize: 16,
    color: '#676767',
    borderBottom: 'solid 1px #676767',
    width: 'max-content',
  },
  '.cannot-print-text-detail': {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    '>div': {
      padding: '16px 0',
      wordBreak: 'keep-all',
    },
  },
})
